import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { assetsSearchRoute } from '@jira/router-routes__assets-app-routes/src/assetsSearchRoute.tsx';
import { assetsSearchEntryPoint } from '@jira/assets-app__search/src/assetsSearchEntryPoint.entrypoint.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
import type { Route } from '@atlassian/react-resource-router';

const assetsSearchPageEntryPoint = createChromelessEntryPoint({
	main: assetsSearchEntryPoint,
});

export const assetsSearchRouteEntry: Route = createEntry(assetsSearchRoute, () => ({
	group: 'assets',
	LayoutOverrideComponent: AssetsLayout,
	PageConfigContainerOverride: AssetsPageConfigContainer,
	skeleton: AssetsSpinner,
	entryPoint: () => assetsSearchPageEntryPoint,
	resources: getAssetsAppResources(),
	forPaint: [LazyAssetsLayout],
	perfMetricKey: 'assets-app.interact-with-search-page',
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
